import { render, staticRenderFns } from "./SolicitudesHub.vue?vue&type=template&id=56beb85f"
import script from "./SolicitudesHub.vue?vue&type=script&lang=js"
export * from "./SolicitudesHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports